import React from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  FormControl,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import CriteriaCondition from './CriteriaCondition';
import Switch from '../UIKit/Switch';
import Select from '../UIKit/Select';
import Button from '../UIKit/Button';
import { useTranslation } from 'react-i18next';

const BadgeCriteriaSelector = ({
  category,
  badgeCriteria,
  advancedCriteriaMode,
  handleToggleAdvancedMode,
  handleOperatorChange,
  handleCriteriaChange,
  handleCriteriaTypeChange,
  handleAdvancedCriteriaParamChange,
  handleAddCondition,
  handleRemoveCondition,
  availableCourses,
  availableAchievements,
  availableTests,
  availableChallenges,
  loadingOptions,
}) => {
  const { t } = useTranslation(['badges']);

  return (
    <Box sx={{ mt: 2 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography variant="subtitle2">
          {t('badges:criteriaSelector.title')}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={advancedCriteriaMode}
              onChange={handleToggleAdvancedMode}
              sx={{ mx: 1 }}
            />
          }
          label={t('badges:criteriaSelector.advancedMode')}
        />
      </Box>

      {advancedCriteriaMode ? (
        // Визуальный конструктор для составных условий
        <Box>
          <Box sx={{ p: 2, mb: 2 }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <Select
                value={badgeCriteria.operator || 'AND'}
                onChange={(e) => handleOperatorChange(e.target.value)}
                label={t('badges:criteriaSelector.logicalOperator')}
              >
                <MenuItem value="AND">
                  {t('badges:criteriaSelector.operators.and')}
                </MenuItem>
                <MenuItem value="OR">
                  {t('badges:criteriaSelector.operators.or')}
                </MenuItem>
              </Select>
              <FormHelperText>
                {badgeCriteria.operator === 'AND'
                  ? t('badges:criteriaSelector.helperText.and')
                  : t('badges:criteriaSelector.helperText.or')}
              </FormHelperText>
            </FormControl>

            {badgeCriteria.conditions &&
              badgeCriteria.conditions.map((condition, index) => (
                <CriteriaCondition
                  key={index}
                  condition={condition}
                  onChange={(key, value) =>
                    handleAdvancedCriteriaParamChange(index, key, value)
                  }
                  onTypeChange={(type) => handleCriteriaTypeChange(type, index)}
                  onRemove={() => handleRemoveCondition(index)}
                  showRemoveButton={badgeCriteria.conditions.length > 1}
                  availableCourses={availableCourses}
                  availableAchievements={availableAchievements}
                  availableTests={availableTests}
                  availableChallenges={availableChallenges}
                  loadingOptions={loadingOptions}
                />
              ))}

            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleAddCondition}
              fullWidth
            >
              {t('badges:criteriaSelector.addCondition')}
            </Button>
          </Box>
        </Box>
      ) : (
        // Простой режим для одного условия
        <CriteriaCondition
          condition={badgeCriteria}
          onChange={handleCriteriaChange}
          onTypeChange={(type) => handleCriteriaTypeChange(type)}
          showRemoveButton={false}
          availableCourses={availableCourses}
          availableAchievements={availableAchievements}
          availableTests={availableTests}
          availableChallenges={availableChallenges}
          loadingOptions={loadingOptions}
        />
      )}
    </Box>
  );
};

export default BadgeCriteriaSelector;
